var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"index"},[_c('el-aside',{staticClass:"left"},[_c('logo'),_c('navs',{on:{"change":_vm.handleChange}}),_c('help')],1),_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }